<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Comentarios />
    </v-container>
  </div>
</template>

<script>
import Comentarios from "../../components/Definiciones/Comentarios/Comentarios.vue";
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
export default {
  components: { Comentarios, LandingToolbar },
};
</script>
